import React, {useState, useEffect, useReducer} from "react";
import moment from "moment";
import "moment/locale/en-gb";
import "moment/locale/es";
import Linkify from "react-linkify";
import extractUrls from "extract-urls";
import {v1 as uuidv1} from "uuid";
import {ReactTinyLink} from 'react-tiny-link'
import {Avatar} from "antd";
import {FolderAddOutlined, MoreOutlined, SendOutlined, ShareAltOutlined} from "@ant-design/icons";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {xcService} from "../../../_services/xcService";

import Microlink from "@microlink/react";
import { concatNameOrAnon, concatNameOrByProfile } from "_helpers";

const Message = (props) => {
    const {item, t, user} = props;
    const [linksPreview, setLinksPreview] = useState([]);
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);

    useEffect(() => {

        let urls = extractUrls(item.comment);

        mountLinks(urls);
    }, []);
    const showDiff = (date) => {

        var duration = moment().diff(moment(date), 'days');

        if (moment(moment(date).format("YYYY-MM-DD")).isSame(moment().format("YYYY-MM-DD"))) {
            return moment(date).format("HH:mm")
        } else {
            if (duration < 5) {
                if (duration === 0) {
                    duration = 1;
                }
                return t("hace") + " " + duration + " " + (duration == 1 ? t("day") : t("days"));
            } else {
                return moment(date).format("DD/MM/YYYY hh:mm")
            }

        }
        return moment(date).format("DD/MM/YYYY hh:mm")
    }


    const mountLinks = async (urls) => {

        let mTempLinks = [];

        if (urls && urls.length > 0) {
            await Promise.all(
                urls.map((url) =>
                    fetch("https://api.peekalink.io/", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "X-API-Key": "7f7cb01d-13ba-44b4-978d-495eef10a3a4"
                        },
                        body: JSON.stringify({"link": url}),
                    }).then((response) => response.json())
                )
            )
                .then((res) => {
                    if (res && res[0]) mTempLinks.push(res[0]);
                })
                .catch((err) => {
                    console.error("Failed to fetch one or more of these URLs:");
                });
        }
        setLinksPreview(mTempLinks);
    };

    const showText = (text) => {


        return (async () => {
            let urls = extractUrls(text);
            let urlsParsed = [];
            if (urls && urls.length > 0) {
                mountLinks(urls).then(res => urlsParsed = res);
            }
            return <>
                <Linkify key={uuidv1()} componentDecorator={componentDecorator}>{text}</Linkify>
                {urls && urls.length > 0 && urls.map(url =>
                    (

                        <ReactTinyLink
                            cardSize="small"
                            showGraphic={true}
                            maxLine={2}
                            minLine={1}
                            url={url}
                        />
                    )
                )}
            </>
        })


    }

    const componentDecorator = (href, text, key) => (
        <Microlink url={href} />

        /*    <a
                href={href}
                key={key}
                target="_blank"
                rel="noopener noreferrer"
            >
                {text}
            </a>*/
    );


    const addToStudentFolder = (url)=>{

        xcService.postToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/saveresource`, url);
    }


    return (
        <>
            <div className={"balloon-text"}>
                <div className={"balloon-info"}>
                    <div className={"balloon-info-top"}>
                        <div className={"name"}>

                            {item.sendByTutor ?
                                <>
                                    {concatNameOrByProfile('TUTOR', moment(item.createdAt).format("YYYY"), item?.tutores?.name, item?.tutores?.surname)}
                                </>
                            :
                            item.sendByOrientador ?
                                <>
                                    {concatNameOrByProfile('COUNSELOR', moment(item.createdAt).format("YYYY"), item?.orientadores?.name, item?.orientadores?.surname)}
                                </>
                            :
                                <>
                                    {concatNameOrAnon(user.name, user.surname)}
                                </>
                            }
                        </div>
                        <div className={"data"}>{showDiff(item.createdAt)}</div>
                    </div>
                    <div className={"type"}>


                        {item.sendByTutor ?  t("isTutor") : item.sendByOrientador ? t("isOrientador") : t("isStudent")}
                    </div>
                </div>
                <p><Linkify key={uuidv1()} componentDecorator={componentDecorator}>{item.comment}</Linkify></p>
                {linksPreview && linksPreview.length > 0 && linksPreview.map(url => {

                    return <div key={uuidv1()} >
                        <div key={uuidv1()}  className={"card-resources-folders is-resources"}>
                            <img src={url.image && url.image.url ? url.image.url : "https://dummyimage.com/58x58/000/fff"} alt={""}  height={58}/>
                            <div className={"card-resources-folders__content"}>
                                <h3 className={"card-resources-folders__title"}>{url.title}</h3>
                                <p className={"card-resources-folders__description"}>{url.description}</p>
                                <a className={"card-resources-folders__link"} href={url.url} target={"_blank"}>{url.url}</a>
                            </div>
                            <div className={"card-resources-folders__menu"}>
                                <button className={"card-resources-folders__menu-btn"}><MoreOutlined /></button>
                                <div className="card-resources-folders__menu-content">
                                    <a href="#"  onClick={()=>addToStudentFolder(url)}><FolderAddOutlined />{t("resources.menu.add")}</a>
                                    {3 === 2 && <a href="#"><SendOutlined />{t("resources.menu.send")}</a>}
                                    {3 === 2 && <a href="#"><ShareAltOutlined />{t("resources.menu.share")}</a>}
                                </div>
                            </div>
                        </div>
                    </div>;
                })

                }
            </div>
        </>
    )
};

export default Message;
